module.exports = __webpack_public_path__ + "img/37.9cbc8e61.png";